import { render, staticRenderFns } from "./digitize.vue?vue&type=template&id=e8a1e594&scoped=true"
import script from "./digitize.vue?vue&type=script&lang=js"
export * from "./digitize.vue?vue&type=script&lang=js"
import style0 from "./digitize.vue?vue&type=style&index=0&id=e8a1e594&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a1e594",
  null
  
)

export default component.exports